/*
 *   File : data-table.js
 *   Author : https://evoqueinnovativelab.com
 *   Description : Data table component
 *   Integrations : react-data-table-component
 *   Version : 1.0.0
 */

import React, { memo } from "react";
import DataTable from "react-data-table-component";
import { PrimaryButton } from "../Cta";

// CustomPagination.jsx (you can keep it inline if you prefer)
const CustomPagination = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  currentPage,
}) => {
  const totalPages = Math.max(1, Math.ceil(rowCount / rowsPerPage));
  const prevDisabled = currentPage <= 1;
  const nextDisabled = currentPage >= totalPages;

  const goTo = (page) => {
    // console.log(currentPage, totalPages);
    if (page < 1) page = 1;
    if (page > totalPages) page = totalPages;
    if (page !== currentPage) onChangePage(page);
  };

  return (
    <div className="d-flex justify-content-between align-items-center w-100 e-bg-floral-white p-3 gap-2 mt-3 e-border-radius-12 px-3">
      <p className="e-font-14 m-0 e-primary-font-poppins fw-medium">
        Page {currentPage} of {totalPages}
      </p>
      <div className="d-flex column-gap-3">
        <PrimaryButton
          ClassName="p-2 e-primary-font-poppins e-font-14 fw-normal bg-white e-border-1px-silver"
          name="Previous"
          onPress={() => goTo(currentPage - 1)}
          disabled={prevDisabled}
        />
        <PrimaryButton
          ClassName="p-2 e-primary-font-poppins e-font-14 fw-normal bg-white e-border-1px-silver"
          name="Next"
          onPress={() => goTo(currentPage + 1)}
          disabled={nextDisabled}
        />
      </div>
    </div>
  );
};

const DataTableComponent = (props) => {
  return (
    // data-table.js (only the DataTable props portion shown)
    <DataTable
      columns={props.columns}
      data={props.data}
      pagination={props.pagination}
      paginationServer={props.paginationServer ?? true}
      paginationPerPage={props.paginationPerPage ?? 10}
      paginationTotalRows={props.paginationTotalRows}
      paginationDefaultPage={props.currentPage || 1} // keeps initial display aligned
      onChangePage={(page) => props.onChangePage && props.onChangePage(page)}
      onChangeRowsPerPage={(newPerPage, page) =>
        props.onChangeRowsPerPage && props.onChangeRowsPerPage(newPerPage, page)
      }
      paginationComponent={
        props.pagination
          ? (paginationProps) => (
              <CustomPagination
                rowsPerPage={paginationProps.rowsPerPage}
                rowCount={paginationProps.rowCount}
                onChangePage={paginationProps.onChangePage}
                // use the parent-controlled page if provided (single source of truth)
                currentPage={props.currentPage ?? paginationProps.currentPage}
              />
            )
          : undefined
      }
      selectableRows={props.selectableRows}
      onSelectedRowsChange={(state) =>
        props.onSelectedRowsChange && props.onSelectedRowsChange(state)
      }
      className={props.className}
      sortIcon={props.sortIcon}
      onRowClicked={props.onRowClicked}
    />
  );
};

DataTableComponent.defaultProps = {
  onRowClicked: () => {},
  data: [],
  pagination: true,
  paginationServer: true,
};

export default memo(DataTableComponent);
